import { translate } from '@vimeo/i18n-runtime';

import ArrowButton from './ArrowButton';
import styles from './PlaylistPlaybar.module.scss';
import ToggleButton from './ToggleButton';

const PlaylistPlaybar = ({
  clips,
  isLoading,
  isMobile,
  nextClip,
  playlistData,
  previousClip,
  selectedClipId,
  toggleTracklist,
  tracklistExpanded,
}) => {
  const isSelectedClip = (e) => e.id === selectedClipId;
  if (typeof clips.find(isSelectedClip) === 'undefined' || clips.findIndex(isSelectedClip) === -1) {
    return null;
  }
  const selectedClipTitle = clips.find(isSelectedClip).title;
  const selectedIndex = clips.findIndex(isSelectedClip);

  const firstClipSelected = selectedIndex === 0;
  const lastClipSelected = selectedIndex === clips.length - 1;

  const expandedClassName = tracklistExpanded ? styles.expanded : '';

  const redDot =
    clips[selectedIndex].isLive && !tracklistExpanded ? <span className={styles.redDot} /> : null;

  const totalVideos = translate({
    singular: '{COUNT} video',
    plural: '{COUNT} videos',
    count: playlistData.total,

    replacements: {
      COUNT: playlistData.total,
    },
  });

  const currentClipOfTotal = translate({
    singular: '{CURRENT_INDEX} of {TOTAL}',

    replacements: {
      CURRENT_INDEX: selectedIndex + 1,
      TOTAL: playlistData.total,
    },
  });

  return (
    <div className={`${styles.playlistPlaybar} ${expandedClassName}`}>
      <ToggleButton
        tracklistExpanded={tracklistExpanded}
        isMobile={isMobile}
        toggleTracklist={toggleTracklist}
      />
      <span className={`${styles.playlistPlaybarVideosCount} ${expandedClassName}`}>
        <span className={styles.playlistPlaybarVideosTotal}>
          {tracklistExpanded ? totalVideos : currentClipOfTotal}
        </span>
        {!tracklistExpanded && (
          <span className={styles.playlistPlaybarSelectedClip} title={selectedClipTitle}>
            {redDot}
            {selectedClipTitle}
          </span>
        )}
      </span>
      <span className={styles.playlistPlaybarArrowContainer}>
        <ArrowButton
          facing="left"
          isMobile={isMobile}
          disable={isLoading || firstClipSelected}
          onClick={previousClip}
          tooltipText={translate('Previous')}
        />
        <ArrowButton
          facing="right"
          isMobile={isMobile}
          disable={isLoading || lastClipSelected}
          onClick={nextClip}
          tooltipText={translate('Next')}
        />
      </span>
    </div>
  );
};

export default PlaylistPlaybar;
